// extracted by mini-css-extract-plugin
export default {"container":"EULA_container__SY-uL","title":"EULA_title__ldcca","updated":"EULA_updated__KWxF7"};